import Analyze from '../view/pages/analyze';
import APIDocs from '../view/pages/apiDocs';
import Home from '../view/pages/home/home';

const routes = {
  '/': Home,
  '/analyze': Analyze,
  '/apidocs': APIDocs,
};

export default routes;
